import TrackingCodeContainer from "./TrackingCodeContainer";

export {
    TrackingCodeContainer
};

export default TrackingCodeContainer;
